/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import { registerDestructor } from '@ember/destroyable';

interface Signature {
  Args: {};
}

export default class DrawerEditorBridge extends Component<Signature> {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;

  constructor(owner: unknown, args: {}) {
    super(owner, args);

    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'content-readiness:open-editor',
      (data) => {
        let eventData = data as {
          activeContentId: number;
          activeContentType: string;
        };
        if (!eventData.activeContentId || !eventData.activeContentType) {
          return;
        }
        this.knowledgeHubDrawerEditorService.openViewDrawer({
          activeContentId: eventData.activeContentId,
          activeContentType: eventData.activeContentType,
        });
      },
    );

    registerDestructor(this, () => {
      unsubscribe();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentReadiness::DrawerEditorBridge': typeof DrawerEditorBridge;
    'content-readiness/drawer-editor-bridge': typeof DrawerEditorBridge;
  }
}
